import { create } from "zustand";
import { persist } from "zustand/middleware";

interface File {
  id: string;
  username: string;
  emailAddress: string;
  avatarPath?: string;
  roles?: string[];
}

interface FileStore {
  currentFile: File | null;
  files: File[];
  currentLanguage: string;
  updateCurrentLanguage: (language: string) => void;
  setCurrentFile: (file: File | null) => void;
  setFiles: (files: File[]) => void;
  clearFile: () => void;
}

export const useFileStore = create<FileStore>()(
  persist(
    (set, get) => ({
      currentFile: null,
      files: [],
      currentLanguage: "zhCN",

      updateCurrentLanguage: (language: string) => {
        set({ currentLanguage: language });
      },

      setCurrentFile: (file: File | null) => {
        set({ currentFile: file });
      },

      setFiles: (files: File[]) => {
        set({ files });
      },

      clearFile: () => {
        set({ currentFile: null });
      },
    }),
    {
      name: "file-store",
      partialize: (state) => ({
        currentLanguage: state.currentLanguage,
      }),
    }
  )
);
